module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-year-label-wrapper",
    class: _vm.numQuarters
  }, [_c('div', {
    staticClass: "cat-year-label"
  }, [_vm._v(_vm._s(_vm.yearData.year))]), _vm._v(" "), _c('div', {
    staticClass: "quarters-label-wrapper"
  }, _vm._l((_vm.yearData.quarters), function(quarter) {
    return _c('div', {
      key: ((_vm.yearData.year) + "_" + (quarter.quarter)),
      staticClass: "quarter-label"
    }, [_vm._v("\n        " + _vm._s(quarter.quarter) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d2c5082","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-controls/MapControlsDatesColumn.vue
// module id = 547
// module chunks = 1